import React, { useCallback } from 'react';

import { Backdrop, Modal, Fade } from '@material-ui/core';
import CloseRounded from '@material-ui/icons/CloseRounded';
import { closeReorderConfirmationModalAction } from 'actions/reorderConfirmationActions';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { Button } from 'styles/admin';
import { StyledTypography, CenterFlexCSS, Divider1, StyledBox } from 'styles/common';

import { StyledIcon } from 'constants/icons';
import theme from 'constants/theme';

const EmployeeFunctionRoleModalFooter = ({ onDiscard, onAction }) => (
  <StyledBox flexcontainer justifycontent="flex-end" style={{ minHeight: '2.5rem', padding: '0 2rem 2rem 2rem' }}>
    <Button blueOutline onClick={onDiscard} size="large" style={{ width: '10rem', padding: '0.3rem 1.5rem' }}>
      <StyledTypography variant="body2" color="primary">
        Discard
      </StyledTypography>
    </Button>
    <Button
      size="large"
      blue
      rightGutter={3}
      style={{ width: '10rem', height: '2.5rem', marginLeft: '1rem', padding: '0' }}
      onClick={onAction}
    >
      <StyledTypography variant="body2" color="white">
        Save
      </StyledTypography>
    </Button>
  </StyledBox>
);

const ReorderConfirmationModal = (props) => {
  const dispatch = useDispatch();
  const { isOpen, onClose, currentState, onSelect } = useSelector((state) => state.reorderConfirmationModal);
  const closeModal = useCallback(() => {
    dispatch(closeReorderConfirmationModalAction());
    // onClose();
  }, [onClose]);

  const onPublish = () => {
    onSelect();
    dispatch(closeReorderConfirmationModalAction());
  };

  return (
    <Modal
      role="reorder-confirmation-dialog"
      open={isOpen}
      onClose={closeModal}
      onBackdropClick={closeModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Container>
          <ModalContainer>
            <StyledHeader closeModal={closeModal} />
            <Divider1 sideMargin={1.5} style={{ marginBottom: '1.5rem' }} />
            <EmployeeFunctionRoleModalFooter
              onDiscard={() => dispatch(closeReorderConfirmationModalAction())}
              onAction={onPublish}
            />
          </ModalContainer>
        </Container>
      </Fade>
    </Modal>
  );
};

const Header = ({ className, closeModal }) => (
  <div className={className}>
    <StyledTypography variant="h6" color="textPrimary">
      Are you sure you want to reorder
    </StyledTypography>
    <StyledTypography variant="body2" color={theme.palette.grey.dark} topGutter={1}>
      Reordering will happen for all the functions
    </StyledTypography>
    <StyledIcon size="fixed24px" style={{ position: 'absolute', top: '1rem', right: '1rem' }} onClick={closeModal}>
      <CloseRounded />
    </StyledIcon>
  </div>
);

export default ReorderConfirmationModal;

const Container = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  ${CenterFlexCSS};
  position: relative;
`;

const ModalContainer = styled.div`
  width: 35rem;
  max-height: 70%;

  border-radius: 4px;

  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
`;

const StyledHeader = styled(Header)`
  position: relative;
  padding: 2rem 1.5rem;
  //   border-bottom: 1px solid ${(props) => props.theme.palette.divider};
`;
